import React, { FC, useMemo } from 'react';
import { useFeatureToggle } from '../../hooks/src/use-feature-toggle';

interface FeatureToggleProps {
  flag: string;
  fallback?: React.ReactNode;
}

const FeatureToggle: FC<FeatureToggleProps> = ({ flag, children, fallback }) => {
  const [isEnabled] = useFeatureToggle();
  fallback = fallback || <></>;
  const isVisible = useMemo(() => {
    return isEnabled(flag);
  }, [flag, isEnabled]);
  return <>{isVisible ? children : fallback}</>;
};

export default FeatureToggle;
